<template lang="pug">
.container.grid-xl
  page-title(title="Nova compra" icon="fas fa-shopping-cart" subtitle="Adicionar compra feita por fora da plataforma")
  fieldset(:disabled="loading")
    form(@submit.prevent="onSubmit")
      .columns
        .column.col-6.col-lg-7.col-md-8.col-sm-12
          .columns
            .column.col-12
              form-group(label="Comprador" :validation="$v.form.person" field="id")
                person-picker(v-model="$v.form.person.$model")
            .column.col-12.mt-2
              .h4 Coleções
              div(v-for="collection, index in collections" :key="collection.id")
                .columns.align-center
                  .column.col-auto
                    img(:src="collection.cover" style="max-width: 30px")
                  .column {{ collection.title }}
                  .column.col-auto
                    a.btn.btn-link.btn-action.btn-sm.text-error.tooltip.tooltip-left(data-tooltip="Retirar" @click="onRemoveCollection(index)")
                      i.fas.fa-trash
                .divider
              collection-picker.my-2(@input="onAddCollection" placeholder="Incluir coleção")
            .column.col-12.mt-2
              .h4 Produtos
              div(v-for="product, index in products" :key="product.id")
                .columns.align-center
                  .column.col-auto
                    img(:src="product.cover" style="max-width: 30px")
                  .column {{ product.title }}
                  .column.col-auto
                    a.btn.btn-link.btn-action.btn-sm.text-error.tooltip.tooltip-left(data-tooltip="Retirar" @click="onRemoveProduct(index)")
                      i.fas.fa-trash
                .divider
              product-picker.my-2(@input="onAddProduct" placeholder="Incluir produto" :collection-ids="collectionIds" :disabled="!collections.length")
            .column.col-12.mt-2
              .h4 Itens de produto
              div(v-for="item, index in productItems" :key="item.id")
                .columns.align-center
                  .column.col-auto(v-if="item.cover")
                    img(:src="item.cover" style="max-width: 30px")
                  .column {{ item.title }}
                  .column.col-auto
                    a.btn.btn-link.btn-action.btn-sm.text-error.tooltip.tooltip-left(data-tooltip="Retirar" @click="onRemoveProductItem(index)")
                      i.fas.fa-trash
                .divider
              product-item-picker.my-2(@input="onAddProductItem" :product-ids="productIds" placeholder="Incluir item de produto" :disabled="!products.length")
            .column.col-12.mt-2
              form-group(label="Valor da compra" :validation="$v.form" field="total")
                masked-money.form-input(v-model.native="$v.form.total.$model" prefix="R$ ")
            .column.col-12.divider
            .column.col-12.text-right
              button.btn.btn-primary(:disabled="$v.$invalid" :class="{loading}")
                i.fas.fa-check
                |  Criar compra
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators'
import purchases from '@/services/purchases'

export default {
  data() {
    return {
      loading: false,
      collections: [],
      products: [],
      productItems: [],
      form: {
        person: { id: null },
        collectionIds: [],
        productIds: [],
        productItemIds: [],
        total: 0,
      },
    }
  },
  computed: {
    collectionIds() {
      return this.collections.map(({ id }) => id)
    },
    productIds() {
      return this.products.map(({ id }) => id)
    },
    productItemIds() {
      return this.productItems.map(({ id }) => id)
    },
  },
  validations() {
    const form = {
      person: { id: { required } },
      total: { minValue: minValue(0), required },
    }

    const { collectionIds, productIds, productItemIds } = this
    let collections = {}
    let products = {}
    let productItems = {}

    if (!collectionIds.length && !productIds.length) {
      productItems = { length: { minValue: minValue(1) } }
    }
    if (!collectionIds.length && !productItemIds.length) {
      products = { length: { minValue: minValue(1) } }
    }
    if (!productIds.length && !productItemIds.length) {
      collections = { length: { minValue: minValue(1) } }
    }
    if (!collectionIds.length && !productIds.length && !productItemIds.length) {
      collections = { length: { minValue: minValue(1) } }
      products = { length: { minValue: minValue(1) } }
      productItems = { length: { minValue: minValue(1) } }
    }
    return { form, collections, products, productItems }
  },
  methods: {
    async onSubmit() {
      const { collectionIds, productIds, productItemIds } = this
      try {
        this.loading = true
        await purchases.create({
          ...this.form,
          collectionIds,
          productIds,
          productItemIds,
        })
        this.$toaster.success('Compra realizada')
        this.$router.back()
      } catch (e) {
        console.log(e)
        this.$toaster.error(`Erro: ${e.message}`)
      } finally {
        this.loading = false
      }
    },
    refreshItems() {
      this.products = this.products.filter(({ collections }) => {
        for (const collection of collections) {
          if (this.collectionIds.includes(collection.id)) return true
        }
        return false
      })
      this.productItems = this.productItems.filter(({ productId }) =>
        this.productIds.includes(productId),
      )
    },
    onRemoveCollection(index) {
      this.$delete(this.collections, index)
      this.refreshItems()
    },
    onAddCollection(collection) {
      if (this.collections.find(item => item.id === collection.id)) {
        this.$toaster.error('Coleção já adicionada')
      } else {
        this.collections.push(collection)
      }
    },
    onRemoveProduct(index) {
      this.$delete(this.products, index)
      this.refreshItems()
    },
    onAddProduct(product) {
      if (this.products.find(item => item.id === product.id)) {
        this.$toaster.error('Produto já adicionado')
      } else {
        this.products.push(product)
      }
    },
    onRemoveProductItem(index) {
      this.$delete(this.productItems, index)
    },
    onAddProductItem(productItem) {
      if (this.productItems.find(item => item.id === productItem.id)) {
        this.$toaster.error('Item de produto já adicionado')
      } else {
        this.productItems.push(productItem)
      }
    },
  },
}
</script>
